module.exports = __webpack_public_path__ + "img/2021-OAW-01-986x310.7af6fe70.png";